import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const R = ({ pre, icon }) => (
  <>
    {pre}
    <FontAwesomeIcon sx={{ fontSize: "0.9em" }} icon={icon} />
  </>
);

R.propTypes = {
  pre: PropTypes.string,
  icon: PropTypes.string,
};

R.defaultProps = {
  pre: "",
  icon: "",
};

function CurrencySymbol({ to }) {
  switch (to) {
    case "INR":
      return <R pre="" icon="rupee-sign" />;
    case "CAD":
      return <R pre="CA" icon="dollar-sign" />;
    case "USD":
      return <R pre="US" icon="dollar-sign" />;
    case "EUR":
      return <R pre="EUR" icon="euro-sign" />;
    default:
      return to;
  }
}

CurrencySymbol.propTypes = {
  to: PropTypes.string.isRequired,
};

export default CurrencySymbol;
